<script setup>
import ProjectMembers from "@/components/projects/ProjectMembers.vue";
</script>

<template>
  <project-members></project-members>
</template>